import actionTypes from '../constants/action-types';

const multilingual = (state = false, action) => {
  if (action.type !== actionTypes.SET_MULTILINGUAL_PROPERTY) return state;
  return action.payload.multilingual;
};

export default multilingual;
